import { render } from "./AssetSuggestions.vue?vue&type=template&id=d827d732"
import script from "./AssetSuggestions.vue?vue&type=script&lang=js"
export * from "./AssetSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__